import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useCartCountStatusReducer = () => useSelector((state: ApplicationState) => state.cartCountStatus);
